import { AutoComplete } from 'antd';
import styled from 'styled-components';

import { ItemText } from '@components/ui/search/SearchResultListStyle';
export const SelectWrapper = styled.div`
  position: relative;
  border-right: 0px solid #000;
  border-left: 0px solid #000;
  border-top: 1px solid #000;
  border-bottom: 1px solid #000;

  @media (min-width: ${({ theme }) => theme.breakPoint.TABLET}) {
    border-right: 1px solid #000;
    border-left: 1px solid #000;
    border-top: 0px solid #000;
    border-bottom: 0px solid #000;
  }
`;

export const OptionWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
`;

export const AntAutoComplete = styled(AutoComplete)<{
  isFocus: boolean;
  isError: boolean;
}>`
  width: 100%;
  .setur-select-selection-search-input {
    height: 80px !important;
    font-weight: 500;
    font-size: 16px;
  }
  .setur-select-selector {
    height: 80px !important;
    border-radius: 0 !important;
    background-color: ${({ isFocus }) =>
      isFocus ? 'rgb(253,244,227)' : '#fff'} !important;
    border: ${({ isFocus, isError }) =>
      isFocus
        ? '3px solid #cb8800'
        : isError
        ? '3px solid #d95c5c'
        : '3px solid #fff'} !important;
  }
  font-weight: 500;
  font-size: 16px;
`;

export const Label = styled.div`
  color: #000;
  font-size: 11px;
  position: absolute;
  top: 8px;
  left: 8px;
  z-index: 1;
`;

export const ErrorMessageContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  position: absolute;
  bottom: -28px;
  left: 50%;
  transform: translateX(-50%);
  z-index: 1;
`;

export const Arrow = styled.div`
  width: 0;
  height: 0;
  border-left: 5px solid transparent;
  border-right: 5px solid transparent;
  border-bottom: 5px solid #f79c7f;
`;

export const ErrorMessage = styled.div`
  white-space: nowrap;
  background-color: #f79c7f;
  font-size: 10px;
  color: #602410;
  font-weight: 400;
  padding: 3px 6px;
`;

export const ItemErrorText = styled(ItemText)`
  color: rgb(226, 35, 27);
  font-size: 14px;
`;
